// extracted by mini-css-extract-plugin
export default {"container":"styles_container__+Yey3","cartLink":"styles_cartLink__Pvqhw","nickName":"styles_nickName__R-EM5","options":"styles_options__otz0z"};